import React from 'react';
import { CheckIcon, FlameIcon, LockIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { EcgLine } from '../EcgLine';
import { FIRST_CTA_ID } from '../FloatingCTA';
import { collectionIncludes, images } from '../../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-white" data-id="element-206" data-mp="hvgzyg34rxxi">
      <div className="flex items-center justify-center gap-2 bg-navy-950 px-4 py-2.5 text-center text-[13px] font-bold text-white sm:text-sm" data-id="element-207" data-mp="hsuuclzsvshx">
        <FlameIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-208" data-mp="qv459cyzdnvu" />
        <span data-id="element-209" data-mp="vmcfucc1rfal">
          Introductory offer: <span className="text-gold" data-id="element-210" data-mp="vndoyb9i5rpo">$27 USD</span> · One-time payment
        </span>
      </div>

      <div className="mx-auto grid max-w-6xl gap-x-12 px-5 pb-14 pt-8 md:grid-cols-2 md:items-center md:pb-20 md:pt-14" data-id="element-211" data-mp="10kdw6pi390id">
        <div className="md:col-start-1 md:row-start-1" data-id="element-212" data-mp="15m396aovfo93">
          <p className="font-display text-xs font-extrabold uppercase tracking-[0.14em] text-pulse sm:text-sm" data-id="element-213" data-mp="1aj3fmmpmut0q">
            The step-by-step ECG learning system for nursing professionals
          </p>
          <h1 className="mt-3 font-display text-[44px] font-black leading-[0.98] text-navy-900 sm:text-6xl lg:text-7xl" data-id="element-214" data-mp="4o6mbng1j181">
            ECG Interpretation <span className="text-pulse" data-id="element-215" data-mp="3vvj1xy19z6lu">Blueprint™</span>
          </h1>
          <p className="mt-5 text-lg font-medium leading-relaxed text-ink sm:text-xl" data-id="element-216" data-mp="3ruh4nmqx54mi">
            Learn a structured approach to ECG interpretation in just{' '}
            <strong className="font-extrabold text-navy-800" data-id="element-217" data-mp="nf7gzza4oals">15 minutes a day</strong> — from basic heart rhythms to
            complex cardiac patterns.
          </p>
          <p className="mt-4 border-l-4 border-pulse pl-4 font-display text-lg font-extrabold leading-snug text-navy-900" data-id="element-218" data-mp="imo7peih41ms">
            Stop memorizing disconnected ECG strips. Start understanding what you’re looking at.
          </p>
        </div>

        <div className="relative mt-8 md:col-start-2 md:row-span-2 md:row-start-1 md:mt-0" data-id="element-219" data-mp="16djutybzi8np">
          <EcgLine animated className="absolute inset-x-[-20px] top-1/2 h-16 w-[calc(100%+40px)] -translate-y-1/2 opacity-25" data-id="element-220" data-mp="30m78aav3j68q" />
          <img src={images.mockup} alt="ECG Interpretation Blueprint™ bundle: six volumes, five bonuses, worksheets and reference charts" className="relative mx-auto w-full max-w-[560px]" data-id="element-221" data-mp="35n392fk5ic9x" />
        </div>

        <div className="mt-6 md:col-start-1 md:row-start-2 md:mt-8" data-id="element-222" data-mp="2hv69bmtz7ap6">
          <p className="text-base leading-relaxed text-muted" data-id="element-223" data-mp="2muium35789pn">
            Six practical volumes to study cardiac rhythms, understand ECG waveforms, recognize important patterns,
            and practice interpretation through guided clinical exercises — for nursing students, new graduates, and
            experienced nurses.
          </p>

          <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-224" data-mp="66y9spyuvmk4">
            {collectionIncludes.map(item => <li key={item} className="flex items-start gap-2.5 text-[15px] font-semibold text-ink" data-id="element-225" data-mp="b3oksyvszryo">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-heal text-white" data-id="element-226" data-mp="1vnk0gmn6bb0v">
                  <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-227" data-mp="1qluqzbfln5ew" />
                </span>
                {item}
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center md:items-start" data-id="element-228" data-mp="20kskytvsnr5a">
            <CTAButton id={FIRST_CTA_ID} label="Yes! I want the ECG Interpretation Blueprint™" data-id="element-229" data-mp="2ecgt6m2x9vgz" />
            <p className="mt-3 flex items-center gap-1.5 text-sm font-medium text-muted" data-id="element-230" data-mp="2aavdyu2x153m">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-231" data-mp="2obxxaz2j01au" />
              Instant digital access · $27 one-time · No subscription
            </p>
          </div>

          <div className="mt-8 flex items-center gap-3" data-id="element-232" data-mp="txn7ooe3x340">
            <img src={images.rachel} alt="Rachel Bennett" className="h-12 w-12 rounded-full object-cover object-top ring-2 ring-white shadow" data-id="element-233" data-mp="ty6r69jenzk5" />
            <p className="text-sm leading-snug text-muted" data-id="element-234" data-mp="qf7ndrus4p9f">
              Created by <strong className="font-bold text-ink" data-id="element-235" data-mp="vdsqq05bvp23">Rachel Bennett</strong>
              <br data-id="element-236" data-mp="10e6q6tsv5qoi" />
              Critical Care Nursing Educator
            </p>
          </div>

          <p className="mt-6 text-xs leading-relaxed text-muted/80" data-id="element-237" data-mp="15cqa6onwcse8">
            The 15-minute reference describes a suggested focused study session. It does not guarantee mastery of ECG
            interpretation or clinical competency within that period.
          </p>
        </div>
      </div>
    </header>;
}